module.exports = __webpack_public_path__ + "static/media/ico-resulve-tus-dudas.0fbdaf2a.svg";